import { useContext } from 'react';
import { StoreContext } from '../../contexts';

export function useCart() {
  const { cart } = useContext(StoreContext);
  if (!cart) return {};
  return cart;
}
